import React from 'react';

var ResponsiveContext = React.createContext({
    view: 'desktop',
    size: 500,
});

export { ResponsiveContext };
